import * as React from 'react'
import Layouts from '../components/Layouts'
import Barchart from '../components/home/Barchart'
import { Row, Col, Card, Button, Tabs } from 'antd'
import {
  EditOutlined,
  CloseOutlined,
  EyeOutlined,
  FileDoneOutlined,
  UserOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from '@ant-design/icons'
import { Form, Select, Table, Tooltip, Popconfirm, Modal } from 'antd'
import moment from 'moment'
import ViewQuotation from './ViewQuotation'
import ViewPolicy from './viewPolicy'
import DownloadPolicyDocuments from './DownloadPolicyDocuments.js'



import CreditNotecomponent from './CreditNote.js'
import apiRequest from '../hooks/ApiRequest.js'
import InsurerPerformanceTable from '../components/InsrurerPerformance.js'
import hasPermissions from '../hooks/Permissions.js'
const { TabPane } = Tabs
function callback() { }
const productNameInLocalStorage = localStorage.getItem('productName')
class Dashboard extends React.Component {
  constructor() {
    super()
    this.state = {
      assetsRisk: false,
      homeInsurance: false,
      funeralInsurance: false,
      legalInsurance: false,
      hospitalInsurance: false,
      claimProcessing: false,
      quotationPermissions: {},
      policyPermissions: {},
      policies: [],
      quotations: [],
      viewQuotation: false,
      ViewPolicy: false,
      creditNote: false,
      policiesExpiring: [],
      ClaimData: [],
      insurerPerformance: {},
      brokerPerformance: [],
      productId: parseInt(localStorage.getItem('productId')),
      productName: localStorage.getItem('productName'),
      loggedInUserID: localStorage.getItem('loggedInUserID'),
      loggedInInsurer: localStorage.getItem('insurerId'),
      LoginUserRoleId: JSON.parse(localStorage.getItem('user')),
      LoginUserRole: JSON.parse(localStorage.getItem('roles')).toLowerCase(),
      columns: [
        {
          key: 'Customer_Name',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: 'Quotation_Number',
          title: 'Quotation Number',
          dataIndex: 'quotationnumber',
        },
        {
          key: 'Policy_Start_Date',
          title: 'Policy Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: ' Policy_End_Date',
          title: 'Policy End Date',
          dataIndex: 'policyexpirytdate',
        },
        {
          key: 'prorata_total_termpremium',
          title: 'Premium',
          dataIndex: 'proratatotaltermpremium',
          render: proratatotaltermpremium => {
            return parseFloat(proratatotaltermpremium).toFixed(2)
          },
        },

        {
          title: 'Actions',
          render: record => (
            <>
              {this.state.quotationPermissions.hasOwnProperty('12') && (
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(record.id)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
              )}
              {this.state.quotationPermissions.hasOwnProperty('13') && (
                <Popconfirm
                  className="delete_btn"
                  title="Are you sure to delete this record?"
                  onConfirm={() => this.deleteRecord(record.id)}>
                  <Tooltip title="Delete">
                    <Button type="danger" style={{ marginLeft: 8 }}>
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              )}
              &nbsp; &nbsp;
              {this.state.quotationPermissions.hasOwnProperty('14') && (
                <Tooltip title="view">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView(record.id)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>
              )}
            </>
          ),
        },
      ],
      columnsForFcpQuotations: [
        {
          key: 'Customer_Name',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: 'Quotation_Number',
          title: 'Quotation Number',
          dataIndex: 'quotationnumber',
        },
        {
          key: 'Policy_Start_Date',
          title: 'Policy Start Date',
          dataIndex: 'policystartdate',
        },
        {
          key: 'prorata_total_termpremium',
          title: 'Premium',
          dataIndex: 'proratatotaltermpremium',
          render: proratatotaltermpremium => {
            return parseFloat(proratatotaltermpremium).toFixed(2)
          },
        },

        {
          title: 'Actions',
          render: record => (
            <>
              {this.state.quotationPermissions.hasOwnProperty('12') && (
                <Tooltip title="Edit">
                  <button
                    className="edit_btn"
                    onClick={() => this.EditRecord(record.id)}>
                    <EditOutlined />
                  </button>
                </Tooltip>
              )}
              {this.state.quotationPermissions.hasOwnProperty('13') && (
                <Popconfirm
                  className="delete_btn"
                  title="Are you sure to delete this record?"
                  onConfirm={() => this.deleteRecord(record.id)}>
                  <Tooltip title="Delete">
                    <Button type="danger" style={{ marginLeft: 8 }}>
                      <DeleteOutlined />
                    </Button>
                  </Tooltip>
                </Popconfirm>
              )}
              &nbsp; &nbsp;
              {this.state.quotationPermissions.hasOwnProperty('14') && (
                <Tooltip title="view">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView(record.id)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>
              )}
            </>
          ),
        },
      ],
      columnsForFcpPolicies: [
        {
          key: 'Customer_Name',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: 'Policy_Number',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: 'Start_Date',
          title: '  Start Date',
          dataIndex: 'policystartdate',
        },
        // {
        //   key: 'End_Date',
        //   title: '  End Date',
        //   dataIndex: 'policyexpirytdate',
        // },
        // {
        //   key: '5',
        //   title: 'Annual Premium',
        //   dataIndex: 'grandtotalannualpremium',
        // },
        {
          key: 'Premium',
          title: 'Premium',
          dataIndex: 'proratatotaltermpremium',
          render: proratatotaltermpremium => {
            return parseFloat(proratatotaltermpremium).toFixed(2)
          },
        },
        {
          key: 'policy_status',
          title: 'Status',
          dataIndex: 'policystatus',
        },
        {
          key: 'Created_Date',
          title: 'Created Date',
          dataIndex: 'createddate',
          render: createddate => moment(createddate).format('YYYY-MM-DD'),
        },
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record) =>
            record.policystatus == 'New Business' ||
              record.policystatus == 'Endorsed' ? (
              <span>
                {this.state.policyPermissions.hasOwnProperty('14') && (
                  <Tooltip title="View">
                    <Button
                      type="primary"
                      className="view_btn"
                      onClick={() => this.handleView2(record.policyid)}>
                      <EyeOutlined />
                    </Button>
                  </Tooltip>
                )}


                {new Date().getDate() === 1 && (
                  <Tooltip title="Edit">
                    <Button
                      type="primary"
                      className="edit_btn"
                      onClick={() => this.handleEditPolicy(record.policyid)}>
                      <EditOutlined />
                    </Button>
                  </Tooltip>
                )}

                <Tooltip title="Download Document">
                  <Button
                    type="primary"
                    className="download_btn"
                    onClick={() => this.handleDownloadPolicy(record.policyid)}
                  >
                    <DownloadOutlined />
                  </Button>
                </Tooltip>

              </span>
            ) : record.policystatus == 'Cancelled' ? (
              <span>

                <Tooltip title="View">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView2(record.policyid)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>{' '}
                &nbsp;&nbsp;
                <Tooltip title="Download Document">
                  <Button
                    type="primary"
                    className="download_btn"
                    onClick={() => this.handleDownloadPolicy(record.policyid)}
                  >
                    <DownloadOutlined />
                  </Button>
                </Tooltip>
              </span>
            ) : (
              <span>
                <Tooltip title="renew">
                  <Button type="primary" className="Renew_btn" success>
                    Renew
                  </Button>

                </Tooltip>
                <Tooltip title="Download Document">
                  <Button
                    type="primary"
                    className="download_btn"
                    onClick={() => this.handleDownloadPolicy(record.policyid)}
                  >
                    <DownloadOutlined />
                  </Button>
                </Tooltip>
              </span>
            ),



        },
      ],
      columns3: [
        {
          key: 'Policy_number',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: 'Expiry_Date',
          title: 'Expiry Date',
          dataIndex: 'policyexpirytdate',
        },
        {
          title: 'Actions',
          render: record => (
            <>
              <Tooltip title="Renew">
                <button
                  className="edit_btn"
                  onClick={() => this.Renew(record.policyid)}>
                  Renew
                </button>
              </Tooltip>


            </>
          ),
        },

      ],
      columns2: [
        {
          key: 'Customer_Name',
          title: 'Customer Name',
          dataIndex: 'customername',
        },
        {
          key: 'Policy_Number',
          title: 'Policy Number',
          dataIndex: 'policynumber',
        },
        {
          key: 'Start_Date',
          title: '  Start Date',
          dataIndex: 'policystartdate',
        },
        ...(productNameInLocalStorage !== 'LEGAL INSURANCE'
          ? [
            {
              key: 'End_Date',
              title: '  End Date',
              dataIndex: 'policyexpirytdate',
            },
            {
              key: 'Premium',
              title: 'Premium',
              dataIndex: 'proratatotaltermpremium',
              render: proratatotaltermpremium => {
                return parseFloat(proratatotaltermpremium).toFixed(2)
              },
            },
          ]
          : [
            {
              key: 'Premium',
              title: 'Monthly Premium',
              dataIndex: 'proratatotaltermpremium',
              render: proratatotaltermpremium => {
                return parseFloat(proratatotaltermpremium).toFixed(2)
              },
            },
          ]),
        // {
        //   key: '5',
        //   title: 'Annual Premium',
        //   dataIndex: 'grandtotalannualpremium',
        // },

        {
          key: 'policy_status',
          title: 'Status',
          dataIndex: 'policystatus',
        },
        {
          key: 'Created_Date',
          title: 'Created Date',
          dataIndex: 'createddate',
          render: createddate => moment(createddate).format('YYYY-MM-DD'),
        },
        {
          title: 'Action',
          dataIndex: 'operation',
          render: (_, record) =>
            record.policystatus == 'New Business' ||
              record.policystatus == 'Endorsed' ? (
              <span>
                {productNameInLocalStorage !== 'LEGAL INSURANCE' && (
                  <Popconfirm
                    title="Do you want to cancel the policy?"
                    onConfirm={() => this.handleCancel(record.policyid)}>
                    <Tooltip title="cancel">
                      <Button type="danger" style={{ marginLeft: 8 }}>
                        <DeleteOutlined />
                      </Button>
                    </Tooltip>
                  </Popconfirm>
                )}
                &nbsp;&nbsp;&nbsp;
                <Tooltip title="View">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView2(record.policyid)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>
                <Tooltip title="Edit">
                  <Button
                    type="primary"
                    className="edit_btn"
                    onClick={() => this.handleEditPolicy(record.policyid)}>
                    <EditOutlined />
                  </Button>
                </Tooltip>

                <Tooltip title="Download Document">
                  <Button
                    type="primary"
                    className="download_btn"
                    onClick={() => this.handleDownloadPolicy(record.policyid)}
                  >
                    <DownloadOutlined />
                  </Button>
                </Tooltip>

              </span>
            ) : record.policystatus == 'Cancelled' ? (
              <span>
                <Tooltip title="credit note">
                  <Button
                    type="primary"
                    className="CreditNote_btn"
                    onClick={() => this.handleCreditNote(record.policyid)}>
                    Credit Note
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;{' '}
                 
                <Tooltip title="Download Document">
                  <Button
                    type="primary"
                    className="download_btn"
                    onClick={() => this.handleDownloadPolicy(record.policyid)}
                  >
                    <DownloadOutlined />
                  </Button>
                </Tooltip>
                <Tooltip title="View">
                  <Button
                    type="primary"
                    className="view_btn"
                    onClick={() => this.handleView2(record.policyid)}>
                    <EyeOutlined />
                  </Button>
                </Tooltip>{' '}
               
              </span>
            ) : (
              <span>
                <Tooltip title="renew">
                  <Button
                    type="primary"
                    className="Renew_btn"
                    success
                    onClick={() => this.Renew(record.policyid)}>
                    Renew
                  </Button>
                </Tooltip>
                &nbsp;&nbsp;{' '}
                <Tooltip title="Download Document">
                  <Button
                    type="primary"
                    className="download_btn"
                    onClick={() => this.handleDownloadPolicy(record.policyid)}
                  >
                    <DownloadOutlined />
                  </Button>
                </Tooltip>
              </span>



            ),
        },
      ],
      ClaimColumes: [
        {
          key: 'customer_name',
          title: 'Customer Name',
          dataIndex: ['claim_creation', 'customer_name'],
        },
        {
          key: 'customer_email',
          title: 'Customer Email',
          dataIndex: ['claim_creation', 'customer_email'],
        },
        {
          key: 'policy_number',
          title: 'Policy Number',
          dataIndex: ['claim_creation', 'policy_number'],
        },
        {
          key: 'itemdetails',
          title: 'Item Detail',
          dataIndex: ['claim_creation', 'itemdetails'],
        },
        {
          key: 'date_of_loss',
          title: 'Date of Loss',
          dataIndex: ['claim_creation', 'date_of_loss'],
        },
        {
          key: 'claim_amount',
          title: 'Claim Amount',
          dataIndex: ['claim_creation', 'claim_amount'],
        },
        {
          key: 'claim_number',
          title: 'Claim Number',
          dataIndex: ['claim_creation', 'claim_number'],
        },
        {
          key: 'claim_status',
          title: 'Claim Status',
          dataIndex: ['claim_creation', 'claim_status'],
        },
      ],
    }
    this.setVisibleFalse2 = this.setVisibleFalse2.bind(this)
    this.setVisibleFalse = this.setVisibleFalse.bind(this)
    this.setVisibleFalse3 = this.setVisibleFalse3.bind(this)
  }

  Renew(val) {
    localStorage.setItem('clientId', val)
    window.location.href = '/endorsedpolicy'
  }

 handleDownloadPolicy = (policyid) => {
  window.location.href = `/DownloadPolicyDocuments/${policyid}`;
};


  componentDidMount() {

    const permissions = hasPermissions('Quotation')
    const policyPermissions = hasPermissions('Policy')

    this.setState({
      quotationPermissions: permissions,
      policyPermissions: policyPermissions,
    })

    // Fetch quotations
    this.fetchQuotations()

    // Fetch policies
    this.fetchPolicies()
    if (this.state.LoginUserRole == 'customer') {
      this.fetchClaimData()
    }
    // Fetch expiring policies (only if productId is not 5 or 3)
    if (this.state.productId !== 5 && this.state.productId !== 3) {
      this.fetchExpiringPolicies()
    }

    // Redirect if userRoles is null
    if (!this.state.LoginUserRole) {
      window.location.href = '/'
    }

    // Set state based on product name
    this.setProductState()
  }

  // Fetch quotations
  async fetchQuotations() {
    try {
      const fetchURL = `${process.env.REACT_APP_BASE_URL}/quotation/GetQuotaions/${this.state.productId}`
      const response = await apiRequest(fetchURL, 'GET')
      this.setState({ quotations: response?.data?.result })
    } catch (error) {
      console.error('Error fetching quotations:', error)
    }
  }
  async fetchClaimData() {
    try {
      const fetchURL = `${process.env.REACT_APP_BASE_URL_CLAIM}/claim/GetAllClaims/`
      const response = await apiRequest(fetchURL, 'GET')
      console.log('response?.data?.result', response?.data?.result)

      this.setState({ ClaimData: response?.data?.result })
    } catch (error) {
      console.error('Error fetching quotations:', error)
    }
  }

  // Fetch policies
  async fetchPolicies() {
    try {
      let fetchURL
      if (this.state.nationalID && this.state.nationalID.length > 0) {
        fetchURL = `${process.env.REACT_APP_BASE_URL
          }/Policy/Getpoliciesbycustomerid/${localStorage.getItem('nationalID')}`
      } else {
        fetchURL = `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicies/${this.state.productId}/All`
      }
      const response = await apiRequest(fetchURL, 'GET')
      this.setState({ policies: response?.data?.result })
    } catch (error) {
      console.error('Error fetching policies:', error)
    }
  }


  async fetchExpiringPolicies() {
    try {
      const fetchURL = `${process.env.REACT_APP_BASE_URL}/Policy/GetPolicies/${this.state.productId}/All`
      const response = await apiRequest(fetchURL, 'GET')
      if (!response?.data?.result) return
      const allPolicies = response.data.result
      const today = new Date()
      const in30Days = new Date()
      in30Days.setDate(today.getDate() + 30)
      const filteredPolicies = allPolicies.filter(policy => {
        const expiryDate = new Date(policy.policyexpirytdate)
        return expiryDate >= today && expiryDate <= in30Days
      })
      console.log(filteredPolicies, '=')

      this.setState({ policiesExpiring: filteredPolicies })
    } catch (error) {
      console.error('Error fetching expiring policies:', error)
    }
  }

  // Set product state based on product name
  setProductState() {
    const { productName } = this.state
    const productMappings = {
      'Assets All Risk': 'assetsRisk',
      'Home Insurance': 'homeInsurance',
      'Funeral Cash Plan': 'funeralInsurance',
      'Hospital Cash Plan': 'hospitalInsurance',
      'Legal Insurance': 'legalInsurance',
      'Claim Processing': 'claimProcessing',
    }

    if (productMappings[productName]) {
      this.setState({ [productMappings[productName]]: true })
    }
  }

  EditRecord(val) {
    localStorage.setItem('clientId', val)
    window.location.href = `/layout/editquotation/${val}`
  }

  deleteRecord(val) {
    // debugger;
    var pid = this.state.productId;
    fetch(`${process.env.REACT_APP_BASE_URL}/quotation/DeleteQuotation/${val}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log('Delete successful:', data);
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
      });

    this.fetchQuotations();
    this.fetchPolicies();

  }

  handleView(val) {
    localStorage.setItem('quotationId', val)
    this.setVisible2()
  }

  setVisible2() {
    this.setState({ viewQuotation: true })
  }
  setVisibleFalse2() {
    this.setState({ viewQuotation: false })
    localStorage.removeItem('quotationId')
    window.location.reload(false)
  }

  handleCancel(val) {
    localStorage.setItem('PolicyID', val)
    window.location.href = '/cancelPolicy'
  }
  handleEditPolicy(val) {
    localStorage.setItem('clientId', val)
    window.location.href = `/endorsedpolicy/${val}`
  }

  handleView2(val) {
    localStorage.setItem('PolicyID', val)
    this.setVisible()
  }

  setVisible() {
    this.setState({ ViewPolicy: true })
  }

  setVisibleFalse() {
    this.setState({ ViewPolicy: false })
    localStorage.removeItem('PolicyID')
    window.location.reload(false)
  }

  handleCreditNote(val) {
    localStorage.setItem('PolicyID', val)
    this.setState({ creditNote: true })
  }

  setVisibleFalse3() {
    this.setState({ creditNote: false })
    localStorage.removeItem('PolicyID')
    window.location.reload()
  }

  render() {
    return (
      <Layouts title="assets" classname="dashboard">
        <Row gutter={24} className="m-t-30 flex">
          <Col lg={16} xs={24}>
            <Card className="dash-white-bg-shadow">
              <div className="graph-heading">
                <h4>Sales Report</h4>
              </div>
              {<Barchart />}
            </Card>
          </Col>
          {this.state.productId == 1 ||
            this.state.productId == 2 ||
            this.state.productId == 4 ? (
            <Col lg={8} xs={24} className="custom-tocard">
              <div className="dash-white-bg-shadow">
                <div className="recent-heading">
                  <h4>Policies Expiring Soon.. </h4>
                </div>
                <div className="recent-post-list">
                  <div className="recent-block-in">
                    <div className="recent-content">
                      <Table
                        rowKey={this}
                        columns={this.state.columns3}
                        dataSource={this.state.policiesExpiring}
                        size="small"
                        pagination={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ) : (
            ''
          )}
        </Row>
        <Row className="m-t-30 m-b-40">
          <div className="dash-white-bg-shadow">
            <Tabs
              className="dash-white-tabs"
              defaultActiveKey="1"
              onChange={callback}>
              <TabPane tab="Quotations " key="1">
                <div className="table-grid-bx">
                  <Table
                    rowKey={this.state.columns.key}
                    columns={
                      this.state.productId === 3 || this.state.productId === 5
                        ? this.state.columnsForFcpQuotations
                        : this.state.columns
                    }
                    dataSource={this.state.quotations}
                    size="small"
                    pagination={false}
                    scroll={{ x: 768 }}
                  />
                </div>
              </TabPane>
              <TabPane tab="Policies" key="2">
                <div className="table-grid-bx">
                  <Table
                    columns={
                      this.state.productId === 3 || this.state.productId === 5
                        ? this.state.columnsForFcpPolicies
                        : this.state.columns2
                    }
                    dataSource={this.state.policies}
                    size="small"
                    pagination={false}
                    scroll={{ x: 768 }}
                  />
                </div>
              </TabPane>
            </Tabs>
          </div>
        </Row>
        {this.state.LoginUserRole == 'customer' && (
          <Row className="m-t-30 m-b-40">
            <div className="dash-white-bg-shadow">
              <div className="dash-white-bg-shadow">
                <div className="recent-heading">
                  <h4>Claim Status </h4>
                </div>
                <div className="recent-post-list">
                  <div className="recent-block-in">
                    <div className="recent-content">
                      <Table
                        rowKey={record => record.claim_creation?.claim_number}
                        columns={this.state.ClaimColumes}
                        dataSource={this.state.ClaimData}
                        size="small"
                        pagination={false}
                        className="custom-claim-table"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Row>
        )}
        <Modal
          title="Quotation Details"
          centered
          visible={this.state.viewQuotation}
          footer={null}
          onCancel={this.setVisibleFalse2}
          width={1000}>
          <ViewQuotation />
        </Modal>
        <Modal
          title="Policy Details"
          centered
          visible={this.state.ViewPolicy}
          footer={null}
          onCancel={this.setVisibleFalse}
          width={1000}>
          <ViewPolicy />
        </Modal>
        <Modal
          title="Policy Details"
          centered
          visible={this.state.creditNote}
          footer={null}
          onCancel={this.setVisibleFalse3}
          width={760}>
          <CreditNotecomponent />
        </Modal>
      </Layouts>
    )
  }
}

export default Dashboard
